import awsEC2SecurityGroups from './awsEC2SecurityGroups';

export default awsEC2SecurityGroups;
